import { OnInit } from '@angular/core';
import { ErrorService } from '../error/error.service';
import * as i0 from "@angular/core";
import * as i1 from "../error/error.service";
var ErrorLoginComponent = /** @class */ (function () {
    function ErrorLoginComponent(errorService) {
        this.errorService = errorService;
    }
    ErrorLoginComponent.prototype.ngOnInit = function () {
        this.linkInitialPage = this.errorService.getUrlInitialPage();
    };
    ErrorLoginComponent.ngInjectableDef = i0.defineInjectable({ factory: function ErrorLoginComponent_Factory() { return new ErrorLoginComponent(i0.inject(i1.ErrorService)); }, token: ErrorLoginComponent, providedIn: "root" });
    return ErrorLoginComponent;
}());
export { ErrorLoginComponent };
